import { faker } from "@faker-js/faker";
import type { Theme } from "./themeTypes";

const THEMES = [
  { name: "Star Wars", weight: 3 },
  { name: "City", weight: 2 },
  { name: "Technic", weight: 2 },
  { name: "Creator Expert", weight: 1 },
  { name: "Ninjago", weight: 1 },
  { name: "Harry Potter", weight: 1 },
  { name: "Marvel", weight: 1 },
  { name: "Architecture", weight: 1 },
] as const;

// Generate a random theme name based on weights
export function getRandomThemeName(): string {
  const totalWeight = THEMES.reduce((sum, t) => sum + t.weight, 0);
  let random = faker.number.int({ min: 1, max: totalWeight });

  for (const theme of THEMES) {
    random -= theme.weight;
    if (random <= 0) return theme.name;
  }
  return THEMES[0].name;
}

export function createTheme(name: string): Theme {
  return {
    id: faker.number.int({ min: 1, max: 100000 }),
    name,
    release: faker.date.past({ years: 5 }),
    symbol: faker.helpers.maybe(() => faker.image.url(), { probability: 0.3 }) ?? null,
  };
}
